import Vue from 'vue';
import { renderer } from '@ui/frontend-app-manager';
import { Entry } from './types/Entry';
import { isFrontendAppEmbedded } from './library/isFrontendAppEmbedded';
import { FrontendApp, createFrontendApp } from './FrontendApp';
import { mountFrontendApp } from './mountFrontendApp';

Vue.config.productionTip = false;

export function main(entry: Entry): void {
  if (isFrontendAppEmbedded()) {
    const frontendApp: FrontendApp = createFrontendApp({ entry });

    renderer.serveFrontendApp({
      name: process.env.VUE_APP_NAME,
      ...frontendApp.getLifecycleHooks()
    });
  } else {
    const frontendApp: FrontendApp = createFrontendApp({
      entry,
      analytics: true
    });

    mountFrontendApp(frontendApp);
  }
}
